import React, {createContext, useContext, useState} from 'react'
import BasicButton from "./BasicButton";
import {ExitModal} from "./BasicModal";
import {getPopupHelpContent} from "../prodect/HelpManager";
import {QuickHelpButton} from "../prodect/ProsCommonUi";

export default function Modal(props) {
    return <div id={props.id} className={"modal"}>
        <div className="modal-overlay" />
        <div className={"modal-window"}
             onMouseDown={(evt) => {
                 evt.stopPropagation()
                 ExitModal(document.getElementById(props.id), props.onClose)
             }}
        >
            <div
                className="modal-content"
                onMouseDown={evt=> evt.stopPropagation()}//has to be
            >
                <header>
                    <h2>{props.header}</h2>
                    {props.helpContext && <QuickHelpButton
                        openCallback={async ()=>{
                            const h = await getPopupHelpContent(props.helpContext)
                            return h
                        }}
                    />}
                    {props.showCloseButton && (
                        <BasicButton
                            icon={"times"}
                            action={()=>{
                                ExitModal(document.getElementById(props.id), props.onClose)
                            }}
                        />
                    )}
                </header>
                {props.children}
            </div>
        </div>
    </div>
}

/**
 * @typedef ModalParams
 * @property {string} heading
 * @property {JSX.Element} content
 */

/**
 * @typedef ModalContext
 * @property {ModalParams | undefined} currentModal
 * @property {(params: ModalParams) => void} openModal
 * @property {() => void} closeModal
 * @property {() => void} closeAllModals
 */

/**
 * @type {React.Context<ModalContext>}
 */
const ModalContext = createContext()

export function ModalProvider(props) {
    const [stack, setStack] = useState([])
    let value = {
        currentModal: stack[0],
        openModal,
        closeModal,
        closeAllModals,
    }
    /**
     * @param {ModalParams} params
     */
    function openModal(params) {
        setStack(stack => {
            value.currentModal = stack
            return [
                {
                    id: "Modal_" + Date.now(),
                    ...params,
                },
                ...stack,
            ]
        })
    }

    function closeModal() {
        let exitElement = document.getElementById(value.currentModal.id)
        if(!exitElement) {
            //if no id then select the latest added popup, might cause bugs
            const openPopups = document.querySelectorAll('.modal')
            exitElement = document.getElementById(openPopups[openPopups.length - 1].id)
        }
        ExitModal(exitElement, ()=>{
            setStack(stack.slice(1))
        })
    }

    function closeAllModals() {
        setStack([])
    }

    return <ModalContext.Provider value={value}>
        {props.children}
        <ModalRoot />
    </ModalContext.Provider>
}

export function useModal() {
    return useContext(ModalContext)
}

export function ModalRoot() {
    const {currentModal, closeModal } = useModal()
    if (currentModal) {
        return <Modal
                id={currentModal.id}
                key={currentModal.id}
                header={currentModal.heading}
                helpContext={currentModal.helpContext}
                showCloseButton
                onClose={()=> closeModal()}
            >
            {currentModal.content}
        </Modal>
    }
    return null
}
